import React from 'react'
import { Paper } from '@mui/material'
import { JmaAlertMessage, JmaAlertMessageProps } from './JmaAlertMessage'
import { HashMap } from 'common/types'
import * as api from 'common/api'
import { useGlobalState } from 'state'
import dayjs from 'dayjs'
import { JmaAlertStatus } from './JmaAlertStatus'

export const JmaAlertContainer = () => {
  const state = useGlobalState()
  const [messages, setMessages] = React.useState<JmaAlertMessageProps[]>([])

  React.useEffect(() => {
    fetchMessages()
  }, [state.app.baseDate])

  const fetchMessages = async (): Promise<void> => {
    const res = await api.get('/alert', {
      point: 'JPGA',
      city: '2210001,2210002',
      river: '850502000100',
      date: state.app.getFormattedBaseDate()
    })
    if (res === null) {
      setMessages([])
      return
    }
    const targets: JmaAlertMessageProps[] = []
    res.forEach((row: HashMap) => {
      targets.push({
        heading: row.heading,
        color: row.color,
        title: row.title,
        area: row.area,
        date: dayjs.utc(row.date, 'YYYY/MM/DD HH:mm').add(9, 'hours').format('YYYY/MM/DD HH:mm'),
        message: row.text + (row.comment ? '\n\n' + row.comment : '')
      })
    })
    setMessages(targets)
  }

  return (
    <>
      <JmaAlertStatus />
      <Paper sx={{backgroundColor: 'transparent', height: '100%', overflowY: 'auto'}} elevation={0} square>
        {
          messages.map((m, index) =>
            <JmaAlertMessage
              key={index}
              {...m}
            />
          )
        }
      </Paper>
    </>
  )
}
